var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-box"},[_c('img',{attrs:{"src":require("@/assets/img/home/facetop.png"),"alt":""}}),_c('div',{staticClass:"m-nav"},_vm._l((_vm.styleList),function(item,index){return _c('div',{key:index,staticClass:"m-item"},[_c('img',{attrs:{"src":item.icoUrl,"alt":""}}),_c('p',[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }